import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class LoggingService {
  constructor(private http: HttpClient) {
  }

  public logError(message: string) {
    let url = `${window.location.origin}/api/logging/logError`;
    const params = new HttpParams().set('message', message);
    this.http.get(url, { params })
      .pipe(map(x => {
        console.log(x);
      }))
      .toPromise();
  }

  public LogInformation(message: string) {
    let url = `${window.location.origin}/api/logging/LogInformation`;
    const params = new HttpParams().set('message', message);
    this.http.get(url, { params })
      .pipe(map(x => {
        console.log(x);
      }))
      .toPromise();
  }

  public LogWarning(message: string) {
    let url = `${window.location.origin}/api/logging/LogWarning`;
    const params = new HttpParams().set('message', message);
    this.http.get(url, { params })
      .pipe(map(x => {
        console.log(x);
      }))
      .toPromise();
  }

  public LogDebug(message: string) {
    let url = `${window.location.origin}/api/logging/LogDebug`;
    const params = new HttpParams().set('message', message);
    this.http.get(url, { params })
      .pipe(map(x => {
        console.log(x);
      }))
      .toPromise();
  }

  public LogTrace(message: string) {
    let url = `${window.location.origin}/api/logging/LogTrace`;
    const params = new HttpParams().set('message', message);
    this.http.get(url, { params })
      .pipe(map(x => {
        console.log(x);
      }))
      .toPromise();
  }
}
